import wixmp from 'wixmp-sdk';


let wixPrivateMedia;

export default function (settings) {
  const { filesUrl, uploadLimits } = settings;
  const privateMediaSettings = {
    apiUrl: filesUrl,
    uploadLimits,
    blackArrow: {
      enabled: true,
    },
    asyncTranscoding: true,
  };

  if (!wixPrivateMedia) {
    try {
      wixPrivateMedia = wixmp.Source(wixmp.sources.PRIVATE, privateMediaSettings);
    } catch (error) {
    }
  }

  return wixPrivateMedia;
}



// WEBPACK FOOTER //
// ./src/transport/utils/wix-private-media.js